import React from 'react'
import PropTypes from 'prop-types'
import {
  Input as StrapInput,
  InputGroup,
  InputGroupText,
  Label,
} from 'reactstrap'

const Input = props => (
  <InputGroup>
    {props.label && <Label htmlFor={props.name}>{props.label}</Label>}
    {props.icon && (
      <InputGroupText>
        <i className={props.icon}></i>
      </InputGroupText>
    )}
    <StrapInput
      type={props.type}
      placeholder={props.placeHolder}
      {...(props.noPaste && {
        onPaste: e => {
          e.preventDefault()
          return false
        },
      })}
      value={props.value}
      onChange={e => props.change(e.target.value)}
      {...(props.required && { required: true })}
      {...(props.name && { name: props.name, id: props.name })}
    />
  </InputGroup>
)

Input.propTypes = {
  icon: PropTypes.string,
  type: PropTypes.string.isRequired,
  placeHolder: PropTypes.string,
  value: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  noPaste: PropTypes.bool,
}

export default Input
